import {Reducer} from "../Reducer/Reducer";
import { combineReducers } from "redux";

const RootReducer = combineReducers({Reducer});

export default RootReducer;
